export const actionTypes = {

    FETCH_WP_USER: 'FETCH_WP_USER',
    FETCH_USER_WP_SUCCESS: 'FETCH_USER_WP_SUCCESS',
    FETCH_USER_WP_FAIL: 'FETCH_USER_WP_FAIL',

    FETCH_WP_POSTS: 'FETCH_WP_POSTS',
    FETCH_POSTS_WP_SUCCESS: 'FETCH_POSTS_WP_SUCCESS',
    FETCH_POSTS_WP_FAIL: 'FETCH_POSTS_WP_FAIL',

    FETCH_WP_POST: 'FETCH_WP_POST',
    FETCH_POST_WP_SUCCESS: 'FETCH_POST_WP_SUCCESS',
    FETCH_POST_WP_FAIL: 'FETCH_POST_WP_FAIL',

    FETCH_WP_CATEGORIES: 'FETCH_WP_CATEGORIES',
    FETCH_WP_CATEGORIES_SUCCESS: 'FETCH_WP_CATEGORIES_SUCCESS',
    FETCH_WP_CATEGORIES_FAIL: 'FETCH_WP_CATEGORIES_FAIL',

    FETCH_WP_ONE_TERM: 'FETCH_WP_ONE_TERM',
    FETCH_WP_ONE_TERM_SUCCESS: 'FETCH_WP_ONE_TERM_SUCCESS',
    FETCH_WP_ONE_TERM_FAIL: 'FETCH_WP_ONE_TERM_FAIL',

    FETCH_WP_TAGS: 'FETCH_WP_TAGS',
    FETCH_WP_TAGS_SUCCESS: 'FETCH_WP_TAGS_SUCCESS',
    FETCH_WP_TAGS_FAIL: 'FETCH_WP_TAGS_FAIL',

    FETCH_WP_PAGES: 'FETCH_WP_PAGES',
    FETCH_WP_PAGES_SUCCESS: 'FETCH_WP_PAGES_SUCCESS',
    FETCH_WP_PAGES_FAIL: 'FETCH_WP_PAGES_FAIL',

    FETCH_WP_MEDIA: 'FETCH_WP_MEDIA',
    FETCH_WP_MEDIA_SUCCESS: 'FETCH_WP_MEDIA_SUCCESS',
    FETCH_WP_MEDIA_FAIL: 'FETCH_WP_MEDIA_FAIL',

    FETCH_WP_STORE: 'FETCH_WP_STORE',
    FETCH_WP_STORE_SUCCESS: 'FETCH_WP_STORE_SUCCESS',
    FETCH_WP_STORE_FAIL: 'FETCH_WP_STORE_FAIL',

    FETCH_WP_CATEGORIES_STORE: 'FETCH_WP_CATEGORIES_STORE',
    FETCH_WP_CATEGORIES_STORE_SUCCESS: 'FETCH_WP_CATEGORIES_STORE_SUCCESS',
    FETCH_WP_CATEGORIES_STORE_FAIL: 'FETCH_WP_CATEGORIES_STORE_FAIL',

    FETCH_WP_TAGS_STORE: 'FETCH_WP_TAGS_STORE',
    FETCH_WP_TAGS_STORE_SUCCESS: 'FETCH_WP_TAGS_STORE_SUCCESS',
    FETCH_WP_TAGS_STORE_FAIL: 'FETCH_WP_TAGS_STORE_FAIL',

    FETCH_WP_PRODUCT: 'FETCH_WP_PRODUCT',
    FETCH_WP_PRODUCT_SUCCESS: 'FETCH_WP_PRODUCT_SUCCESS',
    FETCH_WP_PRODUCT_FAIL: 'FETCH_WP_PRODUCT_FAIL',

    FETCH_WP_ONE_PRODUCT: 'FETCH_WP_ONE_PRODUCT',
    FETCH_WP_PRODUCT_ONE_SUCCESS: 'FETCH_WP_PRODUCT_ONE_SUCCESS',
    FETCH_WP_PRODUCT_ONE_FAIL: 'FETCH_WP_PRODUCT_ONE_FAIL',

    FETCH_WP_ONE_STORE: 'FETCH_WP_ONE_STORE',
    FETCH_WP_STORE_ONE_SUCCESS: 'FETCH_WP_STORE_ONE_SUCCESS',
    FETCH_WP_STORE_ONE_FAIL: 'FETCH_WP_STORE_ONE_FAIL',

    FETCH_WP_CATEGORIES_PRODUCT: 'FETCH_WP_CATEGORIES_PRODUCT',
    FETCH_WP_CATEGORIES_PRODUCT_SUCCESS: 'FETCH_WP_CATEGORIES_PRODUCT_SUCCESS',
    FETCH_WP_CATEGORIES_PRODUCT_FAIL: 'FETCH_WP_CATEGORIES_PRODUCT_FAIL',

    FETCH_WP_TAGS_PRODUCT: 'FETCH_WP_TAGS_PRODUCT',
    FETCH_WP_TAGS_PRODUCT_SUCCESS: 'FETCH_WP_TAGS_PRODUCT_SUCCESS',
    FETCH_WP_TAGS_PRODUCT_FAIL: 'FETCH_WP_TAGS_PRODUCT_FAIL',

    FETCH_WP_MENUS: 'FETCH_WP_MENUS',
    FETCH_WP_MENUS_SUCCESS: 'FETCH_WP_MENUS_SUCCESS',
    FETCH_WP_MENUS_FAIL: 'FETCH_WP_MENUS_FAIL',

    FETCH_WP_HEADER_MENUS: 'FETCH_WP_HEADER_MENUS',
    FETCH_WP_HEADER_MENUS_SUCCESS: 'FETCH_WP_HEADER_MENUS_SUCCESS',
    FETCH_WP__HEADER_MENUS_FAIL: 'FETCH_WP_HEADER_MENUS_FAIL',

    FETCH_WP_CAREER: 'FETCH_WP_CAREER',
    FETCH_CAREER_WP_SUCCESS: 'FETCH_CAREER_WP_SUCCESS',
    FETCH_CAREER_WP_FAIL: 'FETCH_CAREER_WP_FAIL',

};



// WEBPACK FOOTER //
// ./src/constants/actionTypes.tsx